import FqApi from '@/services/fq-api'
import { LabourTimeTypes } from '@/enums'

const baseUrl = '/itemmaster'

export default {
  async getItemMasterByTimesStyle(itemType, timesStyle, query, scheduleId, bodyId) {
    const params = { query, timesStyle }
    if (timesStyle && (timesStyle.toUpperCase() === LabourTimeTypes.NTAR || timesStyle.toUpperCase() === LabourTimeTypes.LTAR)) {
      params.scheduleId = scheduleId
      params.bodyId = bodyId
    }
    const response = await FqApi.get(`${baseUrl}/${encodeURIComponent(itemType)}`, { params })
    return response.data
  }
}